import { GraphQLResult, GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { Button, Col, Row } from "antd";
import { API } from "aws-amplify";
import { useEffect, useState } from "react";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import {
  Navigate,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router";
import { useParams } from "react-router-dom";
import {
  CheckAccountStateQuery,
  CheckLiveSessionQuery,
  Game,
  GenerateGameSessionTokenTimelessTechMutation,
  GetGameByIdQuery,
  GetSessionDataQuery,
  SessionManagementMutation,
} from "../../API";
import { RootState } from "../../app/store";
import {
  GameModeType,
  selectCasinoTheme,
  setGameIdAction,
  setIsInAWindowAction,
  setCloseGameAction,
  setRebuyAction,
} from "../../features/casinotheme";
import {
  PlayerMode,
  selectPlayer,
  updateAccount,
} from "../../features/player/playerSlice";
import {
  Localization,
  selectTheme,
  showFooter,
  showLoading,
  ThemeMode,
} from "../../features/theme/themeSlice";
import {
  generateGameSessionTokenTimelessTech,
  sessionManagement,
} from "../../graphql/mutations";
import {
  checkAccountState,
  checkLiveSession,
  getGameById,
  getSessionData,
} from "../../graphql/queries";
import useAccount from "../../hooks/useAccount";
import AppLocale from "../../lang";
import { ModalBuyIn } from "./ModalBuyIn";
import ModalSessionExists from "./ModalSessionExists";
import { selectConfig } from "../../features/configapp";

type LocationState = {
  gameId: string;
};


const PlayNascosti = () => {
  const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
  const theme = useAppSelector(selectTheme);
  const player = useAppSelector(selectPlayer);
  const config = useAppSelector(selectConfig);
  const locale: Localization = theme.language as any;
  const languages: any = { it: "it-IT", en: "en-US" };
  const language = languages[locale];
  const currentAppLocale = AppLocale[locale];
  const dispatch = useDispatch();
  const location = useLocation();
  const locationState = location.state as LocationState;
  const r = new RegExp(
    "gameId=(?<gameId>[0-9]+)&gameProvider=(?<provider>[a-f0-9-]+)",
    "gmi"
  );

  const locationVars = r.exec(location.search);

  const [gameProvider, setGameProvider] = useState(
    (location.state as LocationState) === null
      ? locationVars[2]
      : locationState.gameId.split("#")[0]
  );
  const [gameId, setGameId] = useState<string>(
    (location.state as LocationState) === null
      ? locationVars[1]
      : locationState.gameId.split("#")[1]
  );

  const [game, setGame] = useState<Game | null>(null);
  const casinoTheme = useAppSelector(selectCasinoTheme);
  const navigate = useNavigate();
  const [sessionToken, setSessionToken] = useState(null);
  const [buyInAmount, setBuyInAmount] = useState<number | null>(null);
  const [existsSession, setExistsSession] = useState<Array<{
    __typename: "GameSession";
    PK?: string | null;
    SK?: string | null;
    lang?: string | null;
    currency?: string | null;
    username?: string | null;
    live?: string | null;
    gameId?: string | null;
    demo?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    liveUpdatedAt?: string | null;
    level?: string | null;
  }> | null>(null);

  const closeSession = (
    sessionToken: string,
    callback: (result: any) => void
  ) => {
    (async () => {
      const result: GraphQLResult<SessionManagementMutation> =
        (await API.graphql({
          query: sessionManagement,
          authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          variables: {
            session: sessionToken,
            oper: "SESSION_CLOSE",
          },
        })) as GraphQLResult<SessionManagementMutation>;
      if (result.data.sessionManagement) {
        return result.data.sessionManagement;
      } else return null;
    })().then((r) => {
      if (callback) {
        callback(r);
      }
    });
  };

  const generateSession = (buyIn: number) => {
    console.log("generateSession::", game, player);
    if (buyIn) {
      (async () => {
        try {
          const result: GraphQLResult<GenerateGameSessionTokenTimelessTechMutation> =
            (await API.graphql({
              query: generateGameSessionTokenTimelessTech,
              authMode: player.logged
                ? GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
                : GRAPHQL_AUTH_MODE.AWS_IAM,
              variables: {
                currency: player.account ? player.account.valute : "EUR",
                lang: language,
                gameId: `${gameProvider}#${gameId}`,
                category: game.category,
                buyIn: buyIn,
              },
            })) as GraphQLResult<GenerateGameSessionTokenTimelessTechMutation>;

          if (result.data.generateGameSessionTokenTimelessTech.length > 20)
            setSessionToken(result.data.generateGameSessionTokenTimelessTech);
        } catch (e) {
          console.error(e);
        }
      })();
    }
  };

  const checkSession = () => {
    const existsLiveSession: boolean = false;
    (async () => {
      try {
        const liveSession: GraphQLResult<CheckLiveSessionQuery> =
          (await API.graphql({
            query: checkLiveSession,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: {
              provider: gameProvider,
            },
          })) as GraphQLResult<CheckLiveSessionQuery>;

        if (liveSession.data !== null) {
          if (liveSession.data.checkLiveSession.length > 0) {
            liveSession.data.checkLiveSession.map((s, i) => {
              closeSession(s.PK.replace("SESSION#", ""), (r) => {
                console.log("Session closed", r);
              });
            });
            //setExistsSession(liveSession.data.checkLiveSession);
          } else {
            setExistsSession(null);
          }
        }
      } catch (error) {}
    })().catch((reason) => {
      console.log("error check live session!!!");
    });
    if (!existsLiveSession) {
      generateSession(buyInAmount);
      dispatch(showLoading(false));
    }
  };

  useEffect(() => {
    if (gameId) {
      (async () => {
        const result: GraphQLResult<GetGameByIdQuery> = (await API.graphql({
          query: getGameById,
          authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          variables: {
            gameId: `${gameProvider}#${gameId}`,
          },
        })) as GraphQLResult<GetGameByIdQuery>;

        if (result.data.getGameById) {
          console.log("game", result);
          setGame(result.data.getGameById);
        }
      })();
    }
  }, [gameId]);

  useEffect(() => {
    if (buyInAmount) {
      generateSession(buyInAmount);
    }
  }, [buyInAmount]);

  useEffect(() => {
    if (player.username !== "") {
      checkSession();
    }
  }, [player]);

  useEffect(() => {
    console.log("casinoTheme.closeGame");
    if (casinoTheme.closeGame) {
      if (sessionToken) {
        closeSession(sessionToken, (r) => {
          console.log("closegameAction", r);
          if (r.success) {
            console.log("session closed", r);
            if (!casinoTheme.isInAWindow) navigate(-1);
            else window.close();
          }
        });
      } else {
        if (!casinoTheme.isInAWindow) navigate("/casino");
        else window.close();
      }
    }
  }, [casinoTheme.closeGame]);

  useEffect(() => {
    if (game) {
      setBuyInAmount(
        parseFloat(player.account.deposit.toFixed(2)) -
          parseFloat(player.account.expenses.toFixed(2)) +
          parseFloat(player.account.winnings.toFixed(2)) +
          parseFloat(player.account.bonus.toFixed(2)) -
          parseFloat(player.account.pickedUp.toFixed(2))
      );
    }
  }, [game]);

  useEffect(() => {
    if (casinoTheme.rebuyGame) {
      closeSession(sessionToken, (r) => {
        if (r.success) {
          (async () => {
            const result: GraphQLResult<CheckAccountStateQuery> =
              (await API.graphql({
                query: checkAccountState,
                authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
              })) as GraphQLResult<CheckAccountStateQuery>;

            setSessionToken(null);
            dispatch(updateAccount(result.data.checkAccountState));
            dispatch(setRebuyAction(false));
          })();
          setBuyInAmount(null);
        }
      });
    }
  }, [casinoTheme.rebuyGame]);

  useEffect(() => {
    if ((location.state as LocationState) === null) {
      dispatch(setIsInAWindowAction(true));
    } else {
      dispatch(setIsInAWindowAction(false));
    }
    dispatch(setGameIdAction({ id: gameId, provider: gameProvider }));
    dispatch(showFooter(false));
    dispatch(setCloseGameAction(false));

    dispatch(setRebuyAction(false));

    return () => {
      console.log("sessionToken", sessionToken);
      if (sessionToken) {
        console.log("Sessione aperta!!!");
      }
    };
  }, []);

  return player.account ? (
    <div
      className="game"
      style={{
        height: "100%",
        padding: "2px 0",
        position: "relative",
        width: "100%",
      }}
    >
      {" "}
      <div className="iframe-container">
        {casinoTheme.gameMode === GameModeType.REAL && sessionToken && game && (
          <iframe
            style={{
              position: "absolute",
              width: "100vw",
              height: `${
                theme.headerStatus
                  ? "calc( 100vh - 150px )"
                  : "calc( 100vh - 70px )"
              }`,
            }}
            frameBorder={0}
            width="100%"
            height="100%"
            scrolling="no"
            src={`
					${game.gameLaunchUrl}/?mode=real&game_id=${gameId}&token=${sessionToken}&currency=${player.account.valute}&language=${language}&operator_id=${config.config.timelesstechOperatorId}&home_url=${config.config.home_url}`}
            title="TimelessTech"
          ></iframe>
        )}
        {casinoTheme.gameMode === GameModeType.DEMO && sessionToken && game && (
          <iframe
            onLoadedData={() => {
              dispatch(showLoading(true));
            }}
            style={{ maxHeight: "848px", maxWidth: "1596.44px" }}
            frameBorder={0}
            width="100%"
            height="100%"
            scrolling="no"
            src={`
					${game.gameLaunchUrl}/?mode=fun&game_id=${gameId}&token=${sessionToken}&currency=${player.account.valute}&language=${language}&device=&operator_id=${config.config.timelesstechOperatorId}&home_url=${config.config.home_url}`}
            title="TimelessTech"
          ></iframe>
        )}
      </div>
      {existsSession && (
        <ModalSessionExists
          playedGameId={`${gameProvider}#${gameId}`}
          sessions={existsSession}
          onContinue={() => {
            setExistsSession(null);
          }}
          onRecovery={(session) => {
            setSessionToken(session.PK.replace("SESSION#", ""));
            setExistsSession(null);
          }}
          onCloseSession={(session) => {
            if (session) {
              closeSession(session.PK.replace("SESSION#", ""), (r) => {
                console.log("Session closed", r);
              });
            }
          }}
        />
      )}
    </div>
  ) : (
    <div
      className="game"
      style={{
        height: "100%",
        padding: "20px 0",
        position: "relative",
        width: "100%",
      }}
    >
      No player
    </div>
  );
};

export default PlayNascosti;
